import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEOHead from "../components/SEOHead";
import { getBlog } from "../lib/api";

export default function BlogList() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        getBlog().then(setPosts);
    }, []);

    return (
        <>
            <SEOHead
                title="The Journal — Cannabis Field Notes from ZenZest"
                description="Strain guides, NY cannabis laws, dispensary buying tips, and delivery maps from the ZenZest team."
                canonical="https://weeddispensarynearme.com/blog"
            />
            <section className="border-b border-zen-ink/8 bg-zen-bg">
                <div className="max-w-[1400px] mx-auto px-6 sm:px-10 py-12 sm:py-16">
                    <p className="text-[11px] uppercase tracking-[0.35em] text-zen-olive mb-6">
                        The Journal
                    </p>
                    <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-light text-zen-ink leading-[0.95] tracking-tight">
                        Slow reads on{" "}
                        <span className="italic text-zen-olive">the plant.</span>
                    </h1>
                    <p className="mt-8 max-w-2xl text-lg text-zen-ink-soft leading-relaxed">
                        Education, buyer guides, and the occasional thought
                        from the team that runs ZenZest.
                    </p>
                </div>
            </section>

            <section className="bg-zen-bg max-w-[1400px] mx-auto px-6 sm:px-10 py-14">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                    {posts.map((p) => (
                        <Link
                            to={`/blog/${p.slug}`}
                            key={p.slug}
                            data-testid={`blog-card-${p.slug}`}
                            className="group bg-zen-surface border border-zen-ink/10 hover:border-zen-olive/60 hover:-translate-y-1 transition-all duration-500 overflow-hidden"
                        >
                            <div className="aspect-[16/10] overflow-hidden bg-zen-bg">
                                <img
                                    src={p.image}
                                    alt={p.title}
                                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                                />
                            </div>
                            <div className="p-7">
                                <p className="text-[10px] uppercase tracking-[0.25em] text-zen-olive mb-3">
                                    {new Date(p.date).toLocaleDateString(
                                        "en-US",
                                        {
                                            month: "long",
                                            day: "numeric",
                                            year: "numeric",
                                        }
                                    )}{" "}
                                    · {p.read_time}
                                </p>
                                <h2 className="font-serif text-xl text-zen-ink font-light leading-tight mb-3">
                                    {p.title}
                                </h2>
                                <p className="text-sm text-zen-ink-soft leading-relaxed mb-5">
                                    {p.excerpt}
                                </p>
                                <span className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-zen-olive">
                                    Read on <ArrowUpRight size={12} />
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>
        </>
    );
}
